/**
 * Mock data for users module
 *
 * Data persists in-memory during the session (NO localStorage)
 */

// ============================================================
// INITIAL MOCK DATA (read-only templates)
// ============================================================

const INITIAL_CURRENT_USER = {
  id: 1,
  username: "dev_user",
  email: "dev@example.com",
  first_name: "Dev",
  last_name: "User",
  role: "manager",
  is_superuser: true,
  tenant: {
    id: 1,
    name: "Dev Tenant"
  }
};

// ============================================================
// IN-MEMORY STATE (mutable during session)
// ============================================================

let currentUserState = JSON.parse(JSON.stringify(INITIAL_CURRENT_USER)); // Deep clone

// ============================================================
// STATE ACCESSORS & MUTATORS
// ============================================================

/**
 * Get current user state
 * @returns {Object}
 */
export const getCurrentUserState = () => currentUserState;

/**
 * Set current user state
 * @param {Object} newUser
 */
export const setCurrentUserState = (newUser) => {
  currentUserState = newUser;
};

/**
 * Reset all state to initial values (useful for testing)
 */
export const resetMockData = () => {
  currentUserState = JSON.parse(JSON.stringify(INITIAL_CURRENT_USER));
};
